import React from 'react';
import {
  SearchSection,
  SearchInput,
  FilterRow,
  FilterItem,
  FilterCheckbox
} from '../../../../styles/components/JobPostManagement';

const SearchFilters = ({ searchQuery, setSearchQuery, filters, setFilters }) => {
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterChange = (e) => {
    const { name, checked } = e.target;
    setFilters({
      ...filters,
      [name]: checked
    });
  };

  return (
    <SearchSection>
      <SearchInput 
        type="text"
        placeholder="Search job posts by title, location, or skills..."
        value={searchQuery}
        onChange={handleSearchChange}
      />
      
      <FilterRow>
        <FilterItem>
          <FilterCheckbox
            type="checkbox"
            id="showActive"
            name="showActive"
            checked={filters.showActive}
            onChange={handleFilterChange}
          />
          <label htmlFor="showActive">Active Posts</label>
        </FilterItem>
        
        <FilterItem>
          <FilterCheckbox
            type="checkbox"
            id="showPending"
            name="showPending"
            checked={filters.showPending}
            onChange={handleFilterChange}
          />
          <label htmlFor="showPending">Pending Posts</label>
        </FilterItem>
        
        <FilterItem>
          <FilterCheckbox
            type="checkbox"
            id="showExpired"
            name="showExpired"
            checked={filters.showExpired}
            onChange={handleFilterChange}
          />
          <label htmlFor="showExpired">Expired Posts</label>
        </FilterItem>
        
        <FilterItem>
          <FilterCheckbox
            type="checkbox"
            id="showPaid"
            name="showPaid"
            checked={filters.showPaid}
            onChange={handleFilterChange}
          />
          <label htmlFor="showPaid">Paid Only</label>
        </FilterItem>
      </FilterRow>
    </SearchSection>
  );
};

export default SearchFilters;
